// extracted by mini-css-extract-plugin
module.exports = {"header_text":"Header_header_text__3IBTV"};